import React from 'react';
import {
  Box,
  Typography,
  Button,
  Container
} from '@mui/material';
import {auth} from '../../firebase'; // Firebase 초기화 파일 경로
import {GoogleAuthProvider, signInWithPopup} from 'firebase/auth'

const GoogleSignupForm = () => {

  const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      alert('Google 계정으로 로그인되었습니다.');
    } catch (error) {
      console.error('Error signing in with Google:', error.message);
      alert('Google 로그인에 실패하였습니다. 다시 시도해주세요.');
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{mt: 8, textAlign: 'center'}}>
        <Typography variant="h4" gutterBottom>
          Signup with Google
        </Typography>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleGoogleSignIn}
        >
          Sign Up with Google
        </Button>
      </Box>
    </Container>
  );
};

export default GoogleSignupForm;
